<template>
    <div class="modal fade Betamount" data-bs-backdrop="static" data-bs-keyboard="false" id="editstackModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5>{{$t('edit-stake','Edit Stake')}}</h5>
                    <button type="button" @click="resetChips()" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="stake_oneclick_bet">
                        <ul>
                            <template v-for="i in 4">
                            <li>
                                <input type="text" maxlength="8" v-model="stake[i-1]" @input="stake[i-1] = $helper.sanitizeNumber(stake[i-1], 10000000)" class="btn-thm m-auto">
                            </li>
                        </template>
                        </ul>
                    </div>
                    <div class="header-but  info-footer edit-stake-btn">
                        <button type="button" @click="resetChips()" class="thm-but thm-bor-but cancel-btn" data-bs-dismiss="modal">{{$t('cancel','Cancel')}}</button>
                        <button type="button" @click="callChangeStakeValue()" class="thm-but">{{$t('save', 'Save')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "StakeModal",
    props:['stakes'],
    data() {
        return {
            stake: this.$store.getters.userTransactionStakes || this.stakes
        }
    },
    mounted() {
         this.resetChips();
    },
    methods: {
          callChangeStakeValue() {
            if(Object.values(this.stake).some(item => item == '') || Object.values(this.stake).some(item => item < 100)){
                this.$errorToast('Stake value must be between 100 to 1Cr.')
                return
            }
            this.$store.dispatch('setUserTransactionStakes', JSON.parse(JSON.stringify(this.stake)));
            this.$successToast('Saved Successfully')
            this.$helper.closeModal('editstackModal');
        },
        resetChips(){
            this.stake = JSON.parse(JSON.stringify(this.$store.getters.userTransactionStakes || this.stakes));
        }
    }
};
</script>